module.exports = require("/home/vsts/work/1/s/src/gatsby/gatsby-browser.ts");